export const VIEW_EVENT_NAME = 'i_testing_full_code_quality_report_total';

export const PAGE_SIZE = 25;
